import {
    COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST as LIST_REQUEST,
    COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE as LIST_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    COMMUNITY_PARTICIPANT_LIST_INVALIDATION
} from "../../../actions/action-types"
import { removeInvalidState } from "./community-participant-utils"
import buildPagingReducer from "../build-paging-reducer"

const defaultReducer = buildPagingReducer({
    LIST_REQUEST,
    LIST_RESPONSE,
    LIST_CACHED_RESPONSE,
    LIST_ERROR_RESPONSE
})

export default (state = {}, action) => {
    const defaultReduction = defaultReducer(state, action)
    switch (action.type) {
        case COMMUNITY_PARTICIPANT_LIST_INVALIDATION:
            return removeInvalidState(defaultReduction, action.communityId)
        default:
            return defaultReduction
    }
}
